import {browserStorageKey} from '@dms/config';

export const triggerFeatureFlagMockChange = () => {
  window.dispatchEvent(new CustomEvent(browserStorageKey.MOCK_FLAGS_KEY));
};
